import "../monacoEnvironment";
import _ from "lodash";
import React, { useState } from "react";
import MonacoEditor from "react-monaco-editor";

interface MonacoProps {
  width: string;
  height: string;
  value: any;
  defaultValue: string;
  language: string;
  theme: any;
  options: {};
  overrideServices: {};
  editorWillMount: any;
  editorDidMount: any;
  editorWillUnmount: any;
  onChange: any;
  className: any;

  id: string;
  debounce?: number;
}
export interface DebouncedCodeEditorProps extends Partial<MonacoProps> {}
const CodeEditorInput = (props: DebouncedCodeEditorProps) => {
  const [value, setValue] = useState(props.defaultValue);

  const changeReduxStore = _.debounce(
    props.onChange ? props.onChange : () => {},
    props.debounce ? props.debounce : 500
  );

  const onChangeDebounced = (newValue: any) => {
    setValue(newValue);
    if (props.onChange) {
      changeReduxStore(newValue);
    }
  };

  return (
    <div id={props.id} className={props.className}>
      <MonacoEditor
        options={{
          minimap: { enabled: false },
          lineNumbersMinChars: 1,
          fixedOverflowWidgets: true,
        }}
        theme="vs-dark"
        height="500"
        language={"html"}
        {...props}
        onChange={onChangeDebounced}
        value={value}
        className=""
      />
    </div>
  );
};

export default CodeEditorInput;
